mcWeb.cart = jQuery.extend(true, mcWeb.cart, new function () {
    this.events = {
        onOrderRefReqChange: "mcWeb.cart.events.onOrderRefReqChange",
        onLoadGiftcards: "mcWeb.cart.events.onLoadGiftcards",
        onShowShipment: "mcWeb.cart.events.onShowShipment"

    };

    this.vm = function (id) { 
        var $ = jQuery;
        var self = this;

        self.id = "#" + id;
        self.service = new WebApiService("Cart");
        self.giftcardService = new WebApiService("Giftcard");
        self.checkoutService = new WebApiService("Checkout");
        self.campaignService = new WebApiService("Campaign");

        self.isMobile = ko.observable();
        self.priceCarrier = ko.observable();
        self.priceCarrierInkVat = ko.observable();

        self.priceTotal = ko.observable();
        self.priceTotalInkVat = ko.observable();
        self.showCurrencyInTotal = ko.observable(false);
        self.currency = ko.observable('');
        self.priceTotalProducts = ko.observable();
        self.priceTotalProductsInkVat = ko.observable();
        self.priceTotalProductsBeforeDiscounts = ko.observable('');
        self.priceTotalProductsBeforeDiscountsInclVat = ko.observable('');

        self.giftVoucherReduction = ko.observable('');
        self.giftVoucherValue = ko.observable('');
        self.hasSpecialFees = ko.observable(false);
        self.giftVoucherUsedValue = ko.observable('');
        self.giftVoucherUsedValueExVat = ko.observable('');
        self.giftVoucherSummaryVisible = ko.computed(function () {
            return self.giftVoucherValue() !== null && self.giftVoucherValue().length > 0;
        });

        self.giftcardsEnabled = false;
        self.giftcardsAdded = ko.observable(false);
        self.giftcards = ko.observableArray();
        self.giftcardTotalDeduction = ko.observable();
        self.priceTotalInkCarrier = ko.observable();
        self.priceTotalInkCarrierInkVat = ko.observable();

        self.summaryPreGiftcardsInkMva = ko.observable();
        self.summaryPreGiftcardsEksMva = ko.observable();
        self.summaryBtoTotalAllProductsAndFees = ko.observable();
        self.totalCampaignDeductions = ko.observable('');
        self.specialFees = ko.observable('');
        self.specialFeesIncVat = ko.observable('');
        self.showSpecialFees = ko.observable(true);

        self.giftcardsTotal = ko.observable();

        self.vatTotal = ko.observable();
        self.vatTotalInkCarrier = ko.observable();
        self.campaingVoucherCanDeductSpecialFees = false;
        self.hasCart = ko.observable();
        self.cartTitle = ko.observable();
        self.cartName = ko.observable();
        self.displayDate = ko.observable();
        self.guId = ko.observable('');
        self.showRRP = ko.observable(false);

        self.itemCount = ko.observable();
        self.cartItems = ko.observableArray();
        self.campaignCodesUsed = ko.observableArray();
        self.hasCampaignCodes = ko.observable(false);
        self.orderbooks = ko.observableArray();

        self.inlineEditor = ko.observable(false);

        self.chkPriceIncExVatPrev = ko.observable(false);
        self.chkPriceIncExVat = ko.observable(false);

        self.avgPlikt = ko.observable(true);
        self.notAvgPlikt = ko.observable(false);

        self.notChkPriceIncExVat = ko.observable(true);

        self.salesMessageVisible = ko.observable(false);
        self.discountVisible = ko.observable(false);

        self.arePricesLocked = ko.observable(false);
        self.hideSomePricesForMport = ko.observable(false);
        self.isLoggedIn = ko.observable();

        self.zipCodePrev = ko.observable();
        self.zipCode = ko.observable('');

        self.shippingPrice = ko.observable();
        self.shippingPriceInkVat = ko.observable();
        self.hasShippingCosts = ko.observable(false);
        self.invoiceFee = ko.observable();
        self.invoiceFeeInkVat = ko.observable();

        self.invoiceFeeAndShipping = ko.observable();
        self.invoiceFeeAndShippingInkVat = ko.observable();
        self.showLeasingCosts = ko.observable(false);
        self.leasingTermAmountExVat = ko.observable('');
        self.leasingFees = ko.observableArray();
        self.leasingAdditionalServices = ko.observableArray();
        self.carrierTypes = ko.observableArray();
        self.selectedCarrierName = ko.observable();
        self.selectedCarrierId = ko.observable();
        self.selectedCarrierPrice = ko.observable();
        self.previousCarrierId = ko.observable(-1);
        self.CampaignCodeTxt = ko.observable('');
        self.CampaignUncombinableTxt = ko.observable('');
        self.CampaignTxt = ko.observable('');
        self.CampaignFreeFreightRequirementTxt = ko.observable('');        
        
        self.messageToSalesDep = ko.observable('');
        self.messageToSalesDepDelayed = ko.computed(function () {
            return self.messageToSalesDep();
        }).extend({ throttle: 300 });

        self.messageBookingRef = ko.observable('');
        self.messageBookingRefDelayed = ko.computed(function () {
            return self.messageBookingRef();
        }).extend({ throttle: 300 });


        self.showLinkTop = ko.observable(true);
        self.showAmountsBottom = ko.observable(false);
        self.showCartAlteration = ko.observable(false);

        self.showMessageToSalesDep = ko.observable(false);
        self.showMessageBookingRef = ko.observable(false);

        self.showDiscountCode = ko.observable(false);
        self.showPriceIncExVat = ko.observable(false);

        self.showRemoveButton = ko.observable(false);
        self.showCart = ko.observable(true);

        self.showContinueShoping = ko.observable(false);

        self.isCartCollapsed = ko.observable(true); //Get the state of the cart is it open or closed
        self.showCartCollapsed = ko.observable(true); // Show cart default Close first time
        self.nordeaComment = ko.observable('');
        self.showNordeaComment = ko.observable(false);
        self.showRemoveCart = ko.observable(false);
        self.showGoToCheckout = ko.observable(false);
        self.showExternalCheckout = ko.observable(false);
        self.showInvoiceFee = ko.observable(false);
        self.showTotalInkCarrier = ko.observable(false);
        self.showEmptyCart = ko.observable(false);
        self.showShipments = ko.observable(false);
        self.SummarySumCostReductionIncVat = ko.observable('');
        self.SummarySumAfterCostReductionIncVat = ko.observable('');
        self.ShowCampaignNames = ko.observable(false);
        self.showVatLine = ko.observable(false);
        self.pricePcs = $("#price-pcs").html();

        self.showRefreshSpin = ko.observable(false);
        self.showRefreshSpinMargin = ko.observable(0);

        self.hrefLogin = ko.observable('#Login');
        self.notFixAmount = ko.observable(true);
        self.isCheckout = ko.observable(false);
        self.showCartItemInfo = ko.observable(false);
        self.showSeparateFraktFakturaCost = ko.observable();
        self.nbrOfDecimals = ko.observable(0);
        self.quantityMaxlength = ko.observable(3);
        self.showAddToFavorite = ko.observable(false);
        self.isBedrift = ko.observable();
        self.quantityStepValue = ko.observable();
        self.packageSizeMode = ko.observable(0);
        self.smallCartFees = false;
        self.orderRefRequired = ko.observable(false);
        self.isOrderRefRequired = ko.computed(function () {
            var status = false;
            if (self.orderRefRequired()) {

                if (self.messageBookingRef() == null ||
                    self.messageBookingRef().trim().length < 1) {
                    status = true;
                }
                if (self.isLoggedIn() || self.isSoftLog === true) {
                    PubSub.publish(mcWeb.cart.events.onOrderRefReqChange, status);
                }
            }
            return status;
        }).extend({ throttle: 1000 });

        self.minimumSessionTimeoutUponLoginOrPurchase = -1;
        self.maximumSessionTimeoutWhenNotLoggedInAndEmptyCart = -1;
        self.sessionEndTime = -1;
        self.sessionEndPopupTime = -1;
        self.showCountdownPopup = false;
        self.countdownInterval = null;
        self.sessionTemplateHtml = null;
        self.OrderbookDate = ko.observable('');
        self.OrderbookEditVisible = ko.computed(function () {
            if (self.OrderbookDate() == null)
                return false;
            else if (self.OrderbookDate() == '')
                return false;
            else return true;
        });

        self.isSoftLog = null;
        self.popupTime = 1000;

        self.summaryBtoWeight = ko.observable("");
        self.summaryBtoVolume = ko.observable("");

        $(document).ready(function () {
            self.popupMsg = $('#NewItemInCartNotifier');
            self.popupMsgWait = self.popupMsg.find('.pop-wait');
            self.popupMsgSuccess = self.popupMsg.find('.pop-success');
            self.popupMsgError = self.popupMsg.find('.pop-error');
            self.popupMsgText = self.popupMsg.find('.cart-popup-text');
            self.cartItemCommentPlaceholder = $("#CartItemCommentPlaceholder").html();
            self.sessionTemplateHtml = $('#session-timout').html();
            self.stepValue = $('#CartItemRemove').attr("step-value");            
        });

        $("#collapse-cartitems").on('shown.bs.collapse', function () {
            self.isCartCollapsed(false);
        });

        $("#collapse-cartitems").on('hidden.bs.collapse', function () {
            self.isCartCollapsed(true);
        });
        
        self.onSelectCart = function (item) {

            var data = { ActiveCartName: item.Name };
            self.service.PostAction("SetActiveCartName", data).then(function (result) {
                PubSub.publish(mcWeb.cart.events.onChangedCart, null);
            });
        };
        //Set the hight of "update icon"
        this.showRefreshSpin.subscribe(function () {
            var hight = parseFloat($("#cart.panel").height());
            if (hight !== NaN && hight > 1) {
                self.showRefreshSpinMargin(((hight / 2) - 30) + 'px');
            }
        });

        self.showEditOrderbookDate = function () {
            mcWeb.orderbookManager.showEditOrderbookDate(self.OrderbookDate(), self.guId(), self.cartName());
        };

        self.deleteOrderbook = function () {
            PubSub.publish(mcWeb.orderbookManager.events.onDoDeleteOrderbook, { Guid: self.guId() });
        };

        self.deleteFavouriteCart = function () {
            PubSub.publish(mcWeb.orderbookManager.events.onDoDeleteOrderbook, { Guid: self.guId() });
        };


        this.priceTotalInkVat.subscribe(function () {
            if (self.priceTotalInkVat() == null || self.priceTotalInkVat().length < 1){
                if(self.hideSomePricesForMport()){
                    self.hideTotalPrice();
                    
                }
                return;
            }

            self.showTotalPrice();
        });

        self.showLeasingCosts.subscribe(function () {
            if (self.priceTotalInkVat() == null || self.priceTotalInkVat().length < 1) {
                if (self.hideSomePricesForMport()) {
                    self.hideTotalPrice();
                }
                return;
            }
            self.showTotalPrice();
        });

        getLibrary("mcWeb.customerRegistration").then(() => {
            PubSub.subscribe(mcWeb.events.customerRegistration.onChangedCustomerData, function (message, data) {
                if (data != null && data.postnrDelivery != null && data.postnrDelivery != self.zipCode()) {
                }

                self.showCart(true);
            });

            PubSub.subscribe(mcWeb.events.customerRegistration.onChangedZipCode, function (message, data) {
                if (!data)
                    return;

                var zipCode = data.zipCode;
                if (zipCode == null)
                    return;

                if (self.zipCode() && zipCode.trim() !== self.zipCode().trim()) {
                    self.LoadZipCode(zipCode);
                }
            });
        });
        PubSub.subscribe(mcWeb.cart.events.onLoadGiftcards, function(message,data){
            self.loadGiftcards(data);
        });

        PubSub.subscribe(mcWeb.cart.events.onChangedCart, function (message, data) {
            self.load(data);
            PubSub.publish(mcWeb.shipment.events.reloadShipment, "");
        });

        

        /*Quantity Small Cart changed*/
        PubSub.subscribe(mcWeb.cartsmall.events.onChangedQuantityCartSmall, function (message, data) {
            self.load();
        });

        PubSub.subscribe(mcWeb.cart.events.onShowShipment, function (message, data) {
            self.showShipments(data.show);
        });

        PubSub.subscribe(mcWeb.shipment.events.onChangedShipment, function (message, data) {
            if (!data)
                return;

            self.loadCarrier(data);
        });

        PubSub.subscribe(mcWeb.shipment.events.onSelectedShipment, function (message, carrier) {
            if (!carrier)
                return;

            self.selectedCarrierName(carrier.Name);
            self.selectedCarrierPrice(carrier.PrintPrice);
        });

        var checkTime = function (i) {
            if (i < 10) { i = "0" + i };  // add zero in front of numbers < 10
            return i;
        }

        self.startSessionCountdown = function () {

            if (self.sessionEndPopupTime < 1)
                return;

            if (self.showCountdownPopup === true) {
                self.showCountdownPopup = false;
                PubSub.publish(mcWeb.lightbox.events.onHideLightbox);
            }


            if (self.countdownInterval != null) {
                clearInterval(self.countdownInterval);
            }

            var t1 = new Date(),
                t2 = new Date(t1);

            //Whats the session time
            self.sessionEndTime = (self.isLoggedIn() === true && self.itemCount() > 0) ? self.minimumSessionTimeoutUponLoginOrPurchase : self.maximumSessionTimeoutWhenNotLoggedInAndEmptyCart;

            // Set the date we're counting down to
            var countDownDate = t2.setMinutes(t1.getMinutes() + self.sessionEndTime);

            // Update the count down every 1 second
            self.countdownInterval = setInterval(function () {

                // Get todays date and time
                var now = new Date().getTime();

                // Find the distance between now an the count down date
                var distance = countDownDate - now;

                // Time calculations for days, hours, minutes and seconds
                var days = Math.floor(distance / (1000 * 60 * 60 * 24));
                var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
                var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
                var seconds = Math.floor((distance % (1000 * 60)) / 1000);


                if (days === 0 && hours === 0 && minutes < self.sessionEndPopupTime) {

                    if (self.showCountdownPopup === false) {
                        self.showCountdownPopup = true;
                        self.showTemplate(self.sessionTemplateHtml);
                        PubSub.publish(mcWeb.lightbox.events.onShowLightbox, { backdrop: 'static', keyboard: false, show: true });
                        document.getElementById("session-btn").addEventListener("click", sessionReload);
                    }

                    // Display the result in the element with id="demo"
                    minutes = checkTime(minutes);
                    seconds = checkTime(seconds);

                    document.getElementById("session-time").innerHTML = minutes + ":" + seconds;
                }

                // If the count down is finished, write some text 
                if (distance < 0) {
                    var el = document.getElementById("session-btn");
                    if (el != null && el.length > 0) {
                        el.removeEventListener("click", sessionReload);
                        el.addEventListener("click", function () {
                            window.location.href = "/";
                        });
                    }


                    clearInterval(self.countdownInterval);

                    $('#session-info').addClass('hidden');
                    $('#session-update').addClass('hidden');
                    $('#session-time').addClass('hidden');
                    $('#session-info-end').removeClass('hidden');
                    $('#session-end').removeClass('hidden');
                    $('#session-time-end').removeClass('hidden');

                }
            }, 1000);
        }

        function sessionReload() {
            self.load(null);
        }

        


        this.load = function (data, settings, triggerOnCartChanged) {

            //Settings
            if (settings) {
                PubSub.publish(mcWeb.login.events.onIsloggedIn, settings.IsLoggedIn);

                self.isCartCollapsed(settings.ShowCartCollapsed);
                self.showCartCollapsed = settings.ShowCartCollapsed;
                self.showRemoveCart(settings.ShowRemoveCart);
                self.showGoToCheckout(settings.ShowGoToCheckout);
                self.showExternalCheckout(settings.ShowExternalCheckout);
                self.showContinueShoping(settings.ShowContinueShoping);
                self.showLinkTop(settings.ShowLinkTop);
                self.showAmountsBottom(settings.ShowAmountsBottom);
                self.showCartAlteration(settings.ShowCartAlteration);
                self.showMessageToSalesDep(settings.ShowMessageToSalesDep);
                self.showMessageBookingRef(settings.ShowMessageBookingRef);
                self.hideSomePricesForMport(settings.HideSomePricesForMport);
                self.giftcardsEnabled = settings.GiftcardsEnabled;
                self.showDiscountCode(settings.ShowDiscountCode);
                self.showPriceIncExVat(settings.ShowPriceIncExVat);
                self.showRemoveButton(settings.ShowRemoveButton);
                self.showCart(settings.ShowCart);
                self.showInvoiceFee(settings.ShowInvoiceFee);
                self.showTotalInkCarrier(settings.ShowTotalInkCarrier);
                self.showShipments(settings.ShowShipment);
                self.hrefLogin(settings.HrefLogin);
                self.isCheckout(($('.body-checkout').length > 0) ? true : false);
                self.inlineEditor(settings.InlineEditor);
                self.showCartItemInfo(settings.ShowCartItemInfo);
                self.showSeparateFraktFakturaCost(settings.ShowSeparateFraktFakturaCost);
                self.nbrOfDecimals(settings.NbrOfDecimals);
                self.quantityMaxlength(settings.QuantityMaxlength);
                self.showAddToFavorite(settings.ShowAddToFavorite);
                self.isBedrift(settings.IsBedrift);
                self.quantityStepValue(settings.QuantityStepValue);
                self.packageSizeMode(settings.PackageSizeMode);
                self.orderRefRequired(settings.OrderRefRequired);
               
                self.minimumSessionTimeoutUponLoginOrPurchase = settings.MinimumSessionTimeoutUponLoginOrPurchase;
                self.maximumSessionTimeoutWhenNotLoggedInAndEmptyCart = settings.MaximumSessionTimeoutWhenNotLoggedInAndEmptyCart;
                self.sessionEndTime = settings.MaximumSessionTimeoutWhenNotLoggedInAndEmptyCart;
                self.campaingVoucherCanDeductSpecialFees = settings.CampaingVoucherCanDeductSpecialFees;
                self.showRRP = settings.ShowRRP;
                self.smallCartFees = settings.SmallCartFees;
                self.sessionEndPopupTime = settings.SessionEndPopupTime;

                
                if (!settings.ShowRegistrationType) {
                    $(".registration-type").hide();
                }

                if ($("#checkout").length > 0)
                    return;// this load method is normally called 4 times when loading the cart page! We skip this one because we know it will be called up to 3 more times started from other events. Only the first call sets settings, so to reduce nbr of calls, we return here
            }

            var vatChanged = (self.chkPriceIncExVat() != self.chkPriceIncExVatPrev());

            if (vatChanged) {
                PubSub.publish(mcWeb.shipment.events.reloadShipment, '');
            }

            //If empty, try to load data with ajax
            if (!data || data == null) {
                var param = {
                    cartName: null,
                    useVat: (vatChanged) ? self.chkPriceIncExVat() : null,
                    discountCode: null,
                    vatChange: vatChanged,
                    isCheckout: self.isCheckout(),
                    guid: getCartIdFromSessionStorage(),
                    favGuid: self.getFavoriteGuid()
                };

                //Update prev Vat
                self.chkPriceIncExVatPrev(self.chkPriceIncExVat());
                self.showRefreshSpin(true);

                self.service.GetAction("LoadCart", param).then(function (result) {

                    self.showRefreshSpin(false);

                    if (result != null) {
                        if (triggerOnCartChanged) {
                            PubSub.publish(mcWeb.cart.events.onChangedCart, result);
                        } else {
                            self.load(result);
                        }
                    }

                });
                return;
            }
            self.ShowCampaignNames($('body.publish-mode').length > 0);

            self.summaryBtoWeight("Total vekt av handlevogn: " + data.SummaryBtoWeight + "kg");
            self.summaryBtoVolume("Totalt volum av handlevogn: " + data.SummaryBtoVolume + "m" + "\xB3");
            self.setFavoriteGuid(data.FavoriteGuid, self.isLoggedIn());
            self.OrderbookDate(data.OrderbookDate);
            self.isMobile(data.IsMobile);
            self.CampaignCodeTxt(data.CampaignCodeTxt);
            self.CampaignTxt(data.CampaignTxt);
            self.CampaignUncombinableTxt(data.CampaignUncombinableTxt);
            self.CampaignFreeFreightRequirementTxt(data.CampaignFreeFreightRequirementTxt);
            if(data.SummarySumAfterCostReductionIncVat != null)
                self.SummarySumAfterCostReductionIncVat(data.SummarySumAfterCostReductionIncVat);
            if(data.SummarySumCostReductionIncVat != null)
                self.SummarySumCostReductionIncVat(data.SummarySumCostReductionIncVat);
            if (self.isMobile())
                $.mobile.loading("hide");

            if (data.CartName != null) {
                self.cartTitle(data.CartTitle);
                self.cartName(data.CartName);
                self.displayDate(data.DisplayDate);
                self.guId(data.GuId);
                PubSub.publish(mcWeb.cart.events.cartGuid, { cartName: data.CartName, cartGuid: data.GuId });
            }

            self.itemCount(mc.format.asCulture(data.ItemCount, self.nbrOfDecimals()));
            self.hasCart(data.HasCart);
            self.showEmptyCart(!data.HasCart);

            if (self.giftcardsEnabled)
                PubSub.publish(mcWeb.cart.events.onLoadGiftcards, data.GuId);

            PubSub.publish(mcWeb.cart.events.hasCartItems, data.HasCart);

            if (self.hasCart()) {

                if (self.isMobile())
                    $("#cart-footer").show();

                if (data.ShowLeasingCosts !== null)
                    self.showLeasingCosts(data.ShowLeasingCosts);

                if (data.LeasingTermAmountExVat !== null)
                    self.leasingTermAmountExVat(data.LeasingTermAmountExVat);

                self.priceCarrier(data.PriceCarrier);
                self.priceCarrierInkVat(data.PriceCarrierInkVat);

                self.priceTotal(data.PriceTotal);
                self.priceTotalInkVat(data.PriceTotalInkVat);
                self.showCurrencyInTotal(data.ShowCurrencyInTotal);
                self.currency(data.Currency);
                self.arePricesLocked(data.ArePricesLocked);

                if(data.SummarySumCostReductionIncVat != null)
                    self.SummarySumCostReductionIncVat(data.SummarySumCostReductionIncVat);
                else self.SummarySumCostReductionIncVat('');

                if(data.SummarySumAfterCostReductionIncVat != null)
                    self.SummarySumAfterCostReductionIncVat(data.SummarySumAfterCostReductionIncVat);
                else self.SummarySumAfterCostReductionIncVat('');

                self.priceTotalProducts(data.PriceTotalProducts);
                self.priceTotalProductsInkVat(data.PriceTotalProductsInkVat);
                self.priceTotalProductsBeforeDiscountsInclVat(data.PriceTotalProductsBeforeDiscountsInclVat);
                self.priceTotalProductsBeforeDiscounts(data.PriceTotalProductsBeforeDiscounts);
                self.summaryPreGiftcardsInkMva(data.SummaryPreGiftcardsInkMva);
                self.summaryPreGiftcardsEksMva(data.SummaryPreGiftcardsEksMva);
                self.giftcardsTotal(data.GiftcardsTotal);
                self.summaryBtoTotalAllProductsAndFees(data.SummaryBtoTotalAllProductsAndFees);
                if (data.TotalCampaignDeductions !== null)
                    self.totalCampaignDeductions(data.TotalCampaignDeductions);
                else self.totalCampaignDeductions(''); 
                
                if(data.SpecialFees !== null)
                    self.specialFees(data.SpecialFees);
                
                if(data.specialFeesIncVat !== null)
                    self.specialFeesIncVat(data.SpecialFeesIncVat);

                self.showSpecialFees(data.ShowSpecialFees === true);

                self.giftVoucherReduction(data.GiftVoucherReduction);
                self.hasSpecialFees(data.HasSpecialFees);
                if (data.GiftVoucherValue !== null && data.GiftVoucherValue.length > 0)
                    self.giftVoucherValue("(" + data.GiftVoucherValue + ")");
                else self.giftVoucherValue('');
                
                if (data.GiftVoucherUsedValue !== null && data.GiftVoucherUsedValue.length > 0)
                    self.giftVoucherUsedValue(data.GiftVoucherUsedValue);
                else self.giftVoucherUsedValue('');

                if (data.GiftVoucherUsedValueExVat !== null && data.GiftVoucherUsedValueExVat.length > 0)
                    self.giftVoucherUsedValueExVat(data.GiftVoucherUsedValueExVat);
                else self.giftVoucherUsedValueExVat('');

                self.priceTotalInkCarrier(data.PriceTotalInkCarrier);
                self.priceTotalInkCarrierInkVat(data.PriceTotalInkCarrierInkVat);

                self.vatTotal(data.VatTotal);
                self.vatTotalInkCarrier(data.VatTotalInkCarrier);

                self.chkPriceIncExVatPrev(data.IncVat);
                self.chkPriceIncExVat(data.IncVat);
                self.avgPlikt(data.AvgPlikt);
                self.notAvgPlikt(!data.AvgPlikt);

                self.zipCodePrev(data.ZipCode);
                self.zipCode(data.ZipCode);

                self.shippingPrice(data.ShippingPrice);
                self.shippingPriceInkVat(data.ShippingPriceInkVat);
                self.hasShippingCosts(data.ShippingPrice.length > 0);
                self.invoiceFee(data.InvoiceFee);
                self.invoiceFeeInkVat(data.InvoiceFeeInkVat);

                self.invoiceFeeAndShipping(data.InvoiceFeeAndShipping);
                self.invoiceFeeAndShippingInkVat(data.InvoiceFeeAndShippingInkVat);

                self.messageToSalesDep(data.MessageToSalesDep);
                self.messageBookingRef(data.MessageBookingRef);

                self.notFixAmount(!data.FixAmount);

                self.isSoftLog = data.IsSoftLog;
                setCarIdInSessionStorage(data);

                if (self.messageToSalesDep() != null && self.messageToSalesDep().trim().length > 0 && self.isCheckout())
                    self.salesMessageVisible(true);

                if (self.messageBookingRef() != null && self.messageBookingRef().trim().length > 0 && self.isCheckout())
                    self.salesMessageVisible(true);

                if (data.Orderbooks !== null)
                    self.orderbooks(data.Orderbooks);
                
                if (data.NordeaApplicationFeesModel !== null && data.NordeaApplicationFeesModel.Comment !== null && data.NordeaApplicationFeesModel.Comment.length > 0) {
                    self.nordeaComment(data.NordeaApplicationFeesModel.Comment);
                    self.showNordeaComment(true);
                }
                else {
                    self.nordeaComment('');
                    self.showNordeaComment(false);
                }


                if (data.NordeaApplicationFeesModel !== null && data.NordeaApplicationFeesModel.StartupFees !== null) {
                    ko.utils.arrayForEach(data.NordeaApplicationFeesModel.StartupFees, function (item) {
                        if (!ko.isObservable(item.AmountStr)) {
                            item.AmountStr = ko.observable(item.AmountStr);
                        }
                        if (!ko.isObservable(item.TypeStr)) {
                            item.TypeStr = ko.observable(item.TypeStr);
                        }
                        if (!ko.isObservable(item.Show)) {
                            item.ShowCost = ko.observable(true);
                        }
                        if (!ko.isObservable(item.Tooltip)) {
                            item.Tooltip = ko.observable(item.Tooltip);
                        }
                    });
                    self.leasingFees(data.NordeaApplicationFeesModel.StartupFees);
                }
                else self.leasingFees(null);
                

                if (data.NordeaApplicationFeesModel !== null && data.NordeaApplicationFeesModel.AdditionalServices !== null) {
                    ko.utils.arrayForEach(data.NordeaApplicationFeesModel.AdditionalServices, function (item) {
                        if (!ko.isObservable(item.AmountStr)) {
                            item.AmountStr = ko.observable(item.AmountStr);
                        }
                        if (!ko.isObservable(item.TypeStr)) {
                            item.TypeStr = ko.observable(item.TypeStr);
                        }
                        if (!ko.isObservable(item.ShowCost)) {
                            item.ShowCost = ko.observable(item.Type !== 'Insurance');
                        }
                        if (!ko.isObservable(item.Tooltip)) {
                            item.Tooltip = ko.observable(item.Tooltip);
                        }
                    });
                    self.leasingAdditionalServices(data.NordeaApplicationFeesModel.AdditionalServices);
                }
                else self.leasingAdditionalServices(null);

                if (data.CampaignCodes !== null && data.CampaignCodes !== undefined) {
                    ko.utils.arrayForEach(data.CampaignCodes, function (item) {
                        if (!ko.isObservable(item.Code)) {
                            item.Code = ko.observable(item.Code);
                        }

                        if (!ko.isObservable(item.Description)) {
                            item.Description = ko.observable(item.Description);
                        }
                        if (!ko.isObservable(item.KKBruktId)) {
                            item.KKBruktId = ko.observable(item.KKBruktId);
                        }
                    });
                    self.hasCampaignCodes(data.CampaignCodes.length > 0);
                    self.campaignCodesUsed(data.CampaignCodes);
                }

                ko.utils.arrayForEach(data.CartItems, function (item) {
                    if (!ko.isObservable(item.Quantity)) {
                        item.Quantity = ko.observable(mc.format.asCulture(item.Quantity, self.nbrOfDecimals()));
                    }

                    if (!ko.isObservable(item.QuantityNbr)) {
                        item.QuantityNbr = ko.observable(item.QuantityNbr);
                    }

                    if (!ko.isObservable(item.QuantityMinimum)) {
                        item.QuantityMinimum = ko.observable(item.QuantityMinimum);
                    }
                    if (!ko.isObservable(item.Price1)) {
                        item.Price1 = ko.observable(item.Price1);
                    }
                    if (!ko.isObservable(item.Price1Stk)) {
                        item.Price1Stk = ko.observable(item.Price1Stk);
                    }
                    if (!ko.isObservable(item.PacksizeLocked)) {
                        item.PacksizeLocked = ko.observable(item.PacksizeLocked);
                    }
                    if (!ko.isObservable(item.Price2)) {
                        item.Price2 = ko.observable(item.Price2);
                    }

                    if (!ko.isObservable(item.LeasingItemCost)) {
                        item.LeasingItemCost = ko.observable(item.LeasingItemCost);
                    }                    
                    if (!ko.isObservable(item.LeasingTotalCost)) {
                        item.LeasingTotalCost = ko.observable(item.LeasingTotalCost);
                    }
                   

                    if (!ko.isObservable(item.ShowConfig)) {
                        item.ShowConfig = ko.observable(false);
                    }
                    if (!ko.isObservable(item.CampaignCode)) {
                        item.CampaignCode = ko.observable(item.CampaignCode);
                    }
                    if (!ko.isObservable(item.FromAutoCampaign)) {
                        item.FromAutoCampaign = ko.observable(item.FromAutoCampaign);
                    }

                    if (!ko.isObservable(item.CampaignCombinable)) {
                        item.CampaignCombinable = ko.observable(item.CampaignCombinable);
                    }

                    if (!ko.isObservable(item.CampaignFreeFreightOnlyForCollectedDelivery)) {
                        item.CampaignFreeFreightOnlyForCollectedDelivery = ko.observable(item.CampaignFreeFreightOnlyForCollectedDelivery);
                    }

                    if (!ko.isObservable(item.ShowQuantity)) {
                        item.ShowQuantity = ko.computed(function () {
                            return (item.CampaignCode().length == 0 && (item.ConfigProducts == null) && !self.hideSomePricesForMport());
                        });
                    }

                    if (!ko.isObservable(item.ShowConfigQuantity)) {
                        item.ShowConfigQuantity = ko.observable(item.ShowConfigQuantity);
                    }


                    if (!ko.isObservable((item.ProduktStatusId))) {
                        item.ProduktStatusId = ko.observable(item.ProduktStatusId);
                    }
                    if (!ko.isObservable((item.GlyphIcon))) {
                        item.GlyphIcon = ko.observable(item.GlyphIcon);
                    }
                    if (!ko.isObservable((item.Packsize))) {
                        item.Packsize = ko.observable(item.Packsize);
                    }
                    if (!ko.isObservable((item.Info))) {
                        item.Info = ko.observable(item.Info);
                    }
                    if (!ko.isObservable((item.FavoriteItemExist))) {
                        item.FavoriteItemExist = ko.observable(item.FavoriteItemExist);
                    }

                    if (!ko.isObservable((item.CostReductionIncVat))) {
                        if(item.CostReductionIncVat !== null)
                            item.CostReductionIncVat = ko.observable(item.CostReductionIncVat);
                        else
                            item.CostReductionIncVat = ko.observable('');
                    }

                    if (!ko.isObservable((item.AmountAfterReductionIncVat))) {
                        if(item.AmountAfterReductionIncVat !== null)
                            item.AmountAfterReductionIncVat = ko.observable(item.AmountAfterReductionIncVat);
                        else
                            item.AmountAfterReductionIncVat = ko.observable('');
                    }
                    if (!ko.isObservable(item.PriceRRP)) {
                        item.PriceRRP = ko.observable(item.PriceRRP);
                    }

                    if (!ko.isObservable(item.TotalLineDiscount)) {
                        item.TotalLineDiscount = ko.observable(item.TotalLineDiscount);
                    }

                    if (!ko.isObservable(item.CampaignItemDetails)) {
                        item.CampaignItemDetails = ko.observableArray(item.CampaignItemDetails);
                    }

                    if (!ko.isObservable(item.CampaignItemSummary)) {
                        item.CampaignItemSummary = ko.observableArray(item.CampaignItemSummary);
                    }

                    if (!ko.isObservable(item.TotalLineDiscountFormatted)) {
                        item.TotalLineDiscountFormatted = ko.observable(item.TotalLineDiscountFormatted);
                    }

                    if (!ko.isObservable(item.AppliedCampaignIds)) {
                        item.AppliedCampaignIds = ko.observable(item.AppliedCampaignIds);
                    }
                    if (!ko.isObservable(item.ShowCampaignInfo)) {
                        item.ShowCampaignInfo = ko.observable(item.AppliedCampaignIds().length > 0);
                    }
                    if (!ko.isObservable(item.CartItemCss)) {
                        item.CartItemCss = ko.observable(self.getCartItemCss(item));
                    }

                    if (!ko.isObservable(item.DiscountCss)) {
                        item.DiscountCss = ko.observable("c-discount "+item.AppliedCampaignIds());
                    }
                    if (!ko.isObservable(item.PriceCss)) {
                        item.PriceCss = ko.observable("c-price " + (item.TotalLineDiscount() > 0 ? "c-price-discounted" : ""));
                    }

                    if (!ko.isObservable(item.PriceSingleCss)) {
                        item.PriceSingleCss = ko.observable("c-price-single " + (item.TotalLineDiscount() > 0 ? "c-price-discounted" : ""));
                    }

                    if (!ko.isObservable(item.LinePriceAfterDiscount)) {
                        item.LinePriceAfterDiscount = ko.observable(item.LinePriceAfterDiscount);
                    }
                });

                self.cartItems(data.CartItems);

                if (self.showShipments() && self.cartItems() != null && self.cartItems().length > 0) {
                    var serviceLocal = new WebApiService("Shipment");
                    serviceLocal.GetAction("CarrierList", { isCheckout: self.isCheckout() }).then(function (result) {
                        PubSub.publish(mcWeb.shipment.events.onChangedShipment, result);
                    });
                }

                self.startSessionCountdown();

                self.showRefreshSpin(false);
                self.showCart(true);
                $("i.financing-tooltip").popover();

            } else {
                self.showRefreshSpin(false);
             //   self.show
                self.showCart(false);

                if (self.isMobile())
                    $("#cart-footer").hide();
            }

            if (self.inlineEditor && !!mcWeb.inlineEditor) {
                mcWeb.inlineEditor.init(true);
            }

            if (self.orderRefRequired() && self.isCheckout()) {
                self.salesMessageVisible(true);
            }
        };



        var setCarIdInSessionStorage = function (data) {

            try {
                if (data.IsSoftLog != null && data.IsSoftLog == true) {
                    window.StorageService.sessionStorage.setItem('sCartId', data.GuId);
                } else {
                    window.StorageService.sessionStorage.removeItem('sCartId');
                }
            } catch (e) {
                // IOS/etc. Private Mode
            }
        }

        var getCartIdFromSessionStorage = function () {

            try {
                var sCartId = window.StorageService.sessionStorage.getItem('sCartId');
                if (sCartId === null || sCartId.length < 30)
                    return null;

                window.StorageService.sessionStorage.removeItem('sCartId'); //reset
                return sCartId;
            } catch (e) {
                // IOS/etc. Private Mode
                return null;
            }
        }


        this.getCartItemCss = function (item) {
            let result = "";
            if (item.CampaignCode != null) {
                if (ko.isObservable(item.CampaignCode) && item.CampaignCode().trim().length > 0)
                    result += "campaign-code ";
                else if (item.CampaignCode.length > 0)
                    result += "campaign-code ";
            }
            if (item.ProduktStatusId !== null) {
                if (ko.isObservable(item.ProduktStatusId) && item.ProduktStatusId() == 5)
                    result += "service-product ";
                else if (item.ProduktStatusId == 5)
                    result += "service-product ";
            }
            
            if (item.AppliedCampaignIds != null) {
                if (ko.isObservable(item.AppliedCampaignIds) && item.AppliedCampaignIds().length > 0)
                    result += "has-campaign " + item.AppliedCampaignIds();
                else if (item.AppliedCampaignIds.length > 0)
                    result += "has-campaign " + item.AppliedCampaignIds;

                result += " " + item.CampaignTypeClasses;
            }

            return result;
        };

        this.toggleDiscount = function () {
            self.discountVisible(!self.discountVisible());
        };

        this.toggleSalesMessage = function () {
            self.salesMessageVisible(!self.salesMessageVisible());
        };

        this.onToggleCarrierTypes = function () {
            $('#carrier-types').slideToggle();
        };

        this.saveSelectedCarrier = function (carrier) {
            self.selectedCarrierName(carrier.Name);
            self.selectedCarrierPrice(carrier.PrintPrice);

            var data = { carrierItem: carrier }

            var shipmentService = new WebApiService("Shipment");

            shipmentService.PostAction("SaveSelectedCarrier", data).then(function (result) {

                PubSub.publish(mcWeb.cart.events.onChangedCart, "");
                PubSub.publish(mcWeb.shipment.events.onSelectedShipment, carrier);

                if (result !== null && result != undefined) {
                    if (result.DoUpdateDeliveryAddress) {

                    }
                }

            });
            return true;
        };

        //Show Configuration items
        this.onClickShowConfig = function (product) {
            product.ShowConfig(!product.ShowConfig());
        };

        this.onClickEditConfig = function (product) {
            self.showRefreshSpin(true);

            self.service.GetAction("EditConfigProduct", { plid: product.ProductId }).then(function (result) {
                self.showRefreshSpin(false);
            });
        };

        this.onClickAssembly = function (product) {

            var data = {
                cartProduktId: product.ProductId,
                isCheckout: true
            }

            self.service.GetAction("ShowSkiAssembly", data).then(function (result) {
                if (result == null || result == false)
                    return;

                if (result == 'mcWeb.SkiAssembly') {
                    getLibrary("skiassembly").then(() => {
                        mcWeb.SkiAssembly.load(true);
                    })
                }
                else if (result == 'mcWeb.SkiAttributeAssembly') {
                    getLibrary("skiattributeassembly").then(() => {
                        mcWeb.SkiAttributeAssembly.load();
                    });
                }
                else if (result === "mcWeb.cart.events.onPopupForProductAssembly") {
                    PubSub.publish(result, product.ProductId);
                }
                else
                    alert('Error - Cant show ski assembly');
            });
        };

        this.onClickFav = function (product) {
            product.FavoriteItemExist(true);
            mcWeb.productlist.fav.add(null, product.Plid, 1, self.isCheckout(),0,-1);//todo: check which fav-cart we want to use
        }

        var timeout;
        //Quantity handler

        var getQuantityStepValue = function (product) {
            if (product.PacksizeLocked()) {
                return product.Packsize();
            }

            if (self.quantityStepValue() != "0") {
                return convertToDesimal(self.quantityStepValue()); // finnes den så tar den precedence over de individuelle Forpakningsstørrelse settingene.
            }
            return product.Packsize();
        };

        this.onClickIncQua = function (product) {

            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }

            var oldQuantity = convertToDesimal(product.Quantity());
            var quantityMinimum = convertToDesimal(product.Packsize());
            var quantityPackSize = convertToDesimal(getQuantityStepValue(product));

            var newQuantity = parseFloat(convertToDesimal(parseFloat(oldQuantity) + parseFloat(quantityPackSize)));

            if (newQuantity < 0 || (newQuantity < quantityMinimum && self.packageSizeMode() != 1)) 
                newQuantity = 0;
            
            product.Quantity(mc.format.asCulture(newQuantity, self.nbrOfDecimals()));

            timeout = setTimeout(function () {
                self.updateQuantity(product, newQuantity, oldQuantity);
            }, 500);

        };

        this.setQua = function (product) {
            checkQuaMin(product);
            var oldQuantity = convertToDesimal(product.Quantity());
            self.updateQuantity(product, parseFloat(oldQuantity), parseFloat(oldQuantity));
        };

        this.onClickDecQua = function (product) {

            if (timeout) {
                clearTimeout(timeout);
                timeout = null;
            }

            var oldQuantity = convertToDesimal(product.Quantity());
            var quantityMinimum = convertToDesimal(product.QuantityMinimum());
            var quantityPackSize = convertToDesimal(getQuantityStepValue(product));

            var newQuantity = parseFloat(convertToDesimal(parseFloat(oldQuantity) - parseFloat(quantityPackSize)));
            if (newQuantity < quantityMinimum)
                newQuantity = 0;

            product.Quantity(mc.format.asCulture(newQuantity, self.nbrOfDecimals()));

            timeout = setTimeout(function () {
                self.updateQuantity(product, newQuantity, oldQuantity);
            }, 500);
        };

        this.onClickRemove = function (product) {
            self.updateQuantity(product, 0);
        };
        this.onClickCampaignCodeRemove = function (campaignCodeUsed) {
            var param = {
                CartGuid: self.guId(),
                CampaignCodeUsedId: campaignCodeUsed.KKBruktId()
            }

            self.campaignService.PostAction("RemoveCampaignFromCart", param)
                .then(function (result) {
                    PubSub.publish(mcWeb.cart.events.onShowNewItemInCartText, { status: result.Success, msg: result.PopupText, popupTime: 2000 });
                    if (result.Success) {
                        self.service.GetAction("RefreshCartCache", { guid: self.guId() }).then(function (result2) {
                            PubSub.publish(mcWeb.cart.events.onChangedCart);
                            PubSub.publish(mcWeb.payments.events.reloadPayments, null);
                        });
                        
                    }
                });
        };
        this.enterKey = function (product, e) {
            if (e.keyCode === 13) {
                document.activeElement.blur();
                return false;
            }
            return true;
        };

        this.onClickRemoveGiftcard = function(giftcard){
            var param = {
                Guid: giftcard.Guid,
                TransactionId: giftcard.TransactionId
            };
            self.giftcardService.PostAction("DeleteTransactionAsync", param).then(function (result){
                if(result){
                   
                    PubSub.publish(mcWeb.cart.events.onChangedCart);
                    PubSub.publish(mcWeb.payments.events.reloadPayments, null);
                }
            });
        };

        var convertToDesimal = function (value) {
            try {
                if (value != null) {
                    value = value.toString().replace(',', '.');//remove ','
                }

                if (isNaN(value))
                    value = 1;

                var q = parseFloat(Math.round(value * 100) / 100).toFixed(self.nbrOfDecimals());
                if (isNaN(q)) {
                    return 1;
                }

                return q;
            } catch (e) {
                return 1;
            }
        };

        var checkQuaMin = function (product) {
            var qt = convertToDesimal(product.Quantity());
            if (isNaN(qt)) {
                qt = 1;
                product.Quantity("1");
            }
            var qtmin = convertToDesimal(product.QuantityMinimum());

            //if quantum is less then minmum package, return minium package.
            if (parseFloat(qt) > 0 && parseFloat(qt) < parseFloat(qtmin)) {
                var qtChange = (parseFloat(qtmin) - parseFloat(qt));
                product.Quantity(qtmin);
                self.quantityQtip($('#quan-' + product.ProductId), $('#pack-quantity').text(), '+' + mc.format.asCulture(qtChange, self.nbrOfDecimals()));
            }
        }

        this.isLastQua = function (quantity, quantityMinimum) {
            var qt = convertToDesimal(quantity);
            if (isNaN(qt)) { qt = 1; }
            var qtmin = convertToDesimal(quantityMinimum);
            return (parseFloat(qt) <= parseFloat(qtmin));
        };

        this.resultQuantity = function (result, product, newQuantity, oldQuantity) {

            self.hasCart(result.HasCart);
            self.itemCount(mc.format.asCulture(result.ItemCount, self.nbrOfDecimals()));

            if (result.PriceTotal) {
                self.showLeasingCosts(result.ShowLeasingCosts);
                self.leasingTermAmountExVat(result.LeasingTermAmountExVat);
                self.priceTotal(result.PriceTotal);
                self.priceTotalInkVat(result.PriceTotalInkVat);
                self.showCurrencyInTotal(result.ShowCurrencyInTotal);
                self.currency(result.Currency);
                self.SummarySumCostReductionIncVat(result.SummarySumCostReductionIncVat);
                self.SummarySumAfterCostReductionIncVat(result.SummarySumAfterCostReductionIncVat);
                self.priceTotalProducts(result.PriceTotalExVatExShipping);
                self.priceTotalProductsInkVat(result.PriceTotalInkVatExShipping);
                self.priceTotalProductsBeforeDiscountsInclVat(result.PriceTotalProductsBeforeDiscountsInclVat);
                self.priceTotalProductsBeforeDiscounts(result.PriceTotalProductsBeforeDiscounts);

                self.giftVoucherReduction(result.GiftVoucherReduction);
                self.giftVoucherValue(result.GiftVoucherValue);
                self.hasSpecialFees(result.HasSpecialFees);

                self.priceTotalInkCarrier(result.PriceTotalInkCarrier);
                self.priceTotalInkCarrierInkVat(result.PriceTotalInkCarrierInkVat);

                self.shippingPrice(result.ShippingPrice);
                self.shippingPriceInkVat(result.ShippingPriceInkVat);
                self.hasShippingCosts(result.ShippingPrice.length > 0);
                self.invoiceFee(result.InvoiceFee);
                self.invoiceFeeInkVat(result.InvoiceFeeInkVat);

                self.invoiceFeeAndShipping(result.InvoiceFeeAndShipping);
                self.invoiceFeeAndShippingInkVat(result.InvoiceFeeAndShippingInkVat);
                self.leasingTermAmountExVat(result.LeasingTermAmountExVat);

            }

            if (result.VatTotal) {
                self.vatTotal(result.VatTotal);
                self.vatTotalInkCarrier(result.VatTotalInkCarrier);
                PubSub.publish(mcWeb.shipment.events.reloadShipment, "");
            }

            if (!self.hasCart()) {
                self.cartItems.removeAll();

                PubSub.publish(mcWeb.cart.events.hasCartItems, self.hasCart());
                self.showEmptyCart(true);
                return;

            } else if (result.CartItems == null || (result.CartItems.length < 1)) {
                self.cartItems.remove(product);
            } else {
                if (result.CartItems != null) {
                    var qua = mc.format.asNumber(result.CartItems[0].Quantity, self.nbrOfDecimals()); //parseFloat(result.CartItems[0].Quantity);
                    oldQuantity = mc.format.asNumber(oldQuantity, self.nbrOfDecimals());
                    newQuantity = mc.format.asNumber(newQuantity, self.nbrOfDecimals());

                    //Check if quantity is NOT changed
                    if (oldQuantity == qua && oldQuantity != newQuantity) {
                        self.quantityQtip($('#quan-' + product.ProductId), $('#no-quantity').text());
                    }
                    //Check if quantity is changed width more then newQuantity
                    else if (newQuantity != qua) {
                        var changeQua = (qua - oldQuantity);
                        var text = ' ' + ((changeQua > 0) ? '+' : '') + mc.format.asCulture(changeQua, self.nbrOfDecimals());

                        if (result.CartItems[0].Packsize == 1) {
                            self.quantityQtip($('#quan-' + product.ProductId), $('#max-quantity').text() + ' ' + mc.format.asCulture(qua, self.nbrOfDecimals()) + ' ' + $('#instock-quantity').text(), '');
                        } else {
                            self.quantityQtip($('#quan-' + product.ProductId), $('#pack-quantity').text(), text);
                        }
                    }

                    product.Quantity(mc.format.asCulture(result.CartItems[0].Quantity, self.nbrOfDecimals()));
                    product.QuantityNbr(result.CartItems[0].QuantityNbr);
                    product.Price1(result.CartItems[0].Price1);
                    product.Price1Stk(result.CartItems[0].Price1Stk);
                    product.PacksizeLocked(result.CartItems[0].PacksizeLocked);
                    product.Price2(result.CartItems[0].Price2);
                    product.CampaignCode(result.CartItems[0].CampaignCode);
                    product.FromAutoCampaign(result.CartItems[0].FromAutoCampaign);
                    product.PriceRRP(result.CartItems[0].PriceRRP);
                    product.TotalLineDiscount(result.CartItems[0].TotalLineDiscount);
                    product.TotalLineDiscountFormatted(result.CartItems[0].TotalLineDiscountFormatted);
                    product.AppliedCampaignIds(result.CartItems[0].AppliedCampaignIds);
                    product.ShowCampaignInfo(result.CartItems[0].AppliedCampaignIds != null && result.CartItems[0].AppliedCampaignIds.length > 0);
                    product.CartItemCss(self.getCartItemCss(result.CartItems[0]));
                    product.LeasingItemCost(result.CartItems[0].LeasingItemCost);
                    product.LeasingTotalCost(result.CartItems[0].LeasingTotalCost);
                    product.LinePriceAfterDiscount(result.CartItems[0].LinePriceAfterDiscount);
                }
            }

            if (document.activeElement)
                document.activeElement.blur();
        };


        this.updateQuantity = function (product, newQuantity, oldQuantity) {
            var data = {
                plid: product.ProductId,
                quantity: newQuantity,
                cartName: null,
                isCheckout: self.isCheckout(),
                info: product.Info()
            };

            self.showRefreshSpin(true);

            self.service.GetAction("UpdateCartItem", data).then(function (result) {
                self.showRefreshSpin(false);
                if (self.isCheckout()
                    && mcWeb.customerRegistration !== undefined
                    && mcWeb.customerRegistration !== null
                    && mcWeb.customerRegistration.instances['checkout-registration'] !== null
                    && mcWeb.customerRegistration.instances['checkout-registration'] !== undefined)
                {
                    var registrationVM = mcWeb.customerRegistration.instances['checkout-registration'].registrationVM;
                    if (registrationVM.usingPorterbuddy() && porterbuddy !== undefined && porterbuddy.refresh !== undefined) {
                        //This variable should have been injected by Porterbuddy, if the Porterbuddy module is active.

                        porterbuddy.refresh();
                    }
                }

                if (result == null)
                    return;

                PubSub.publish(mcWeb.events.freeShippingTxt.onUpdateFreeShipping);

                var pubObject = new Object();
                pubObject.result = result;
                pubObject.newQuantity = newQuantity;
                pubObject.ProductId = product.ProductId;

                self.resultQuantity(result, product, newQuantity, oldQuantity);

                PubSub.publish(mcWeb.cart.events.onChangedQuantityCart, pubObject);

                if (result.WebCartProductIdsRemoved != null && result.WebCartProductIdsRemoved.length > 0 || result.RequireFullRefresh)
                    PubSub.publish(mcWeb.cart.events.onChangedCart, null);
                if (result.CampaignVerificationModel !== null && !result.CampaignVerificationModel.Success && result.CampaignVerificationModel.VerificationResult !== null && !result.CampaignVerificationModel.VerificationResult.Success) {
                    var target = $("#campaing-code-field");
                    mcWeb.validation.qTipActionShowAndHide(target, result.CampaignVerificationModel.VerificationResult.ErrorMsg, false, self.getqTipDelay(result.CampaignVerificationModel.VerificationResult.ErrorMsg));
                }

                if (result.GiftcardsTotal !== null && result.GiftcardsTotal.length > 0) {
                    PubSub.publish(mcWeb.cart.events.onLoadGiftcards, self.guId());
                }
                PubSub.publish(mcWeb.payments.events.reloadPayments, null);
            });

        };

        this.quantityQtip = function (sender, text, quantity) {

            var textQua = (quantity) ? ('<span class="bold">' + convertToDesimal(quantity) + '</span>') : '';
            sender.qtip({
                content: { text: text + textQua },
                hide: {
                    inactive: 5000,
                    event: 'click mouseleave mouseover',
                    effect: function () { $(this).slideUp(); }
                },
                position: { my: 'top center', at: 'bottom center' },
                style: { classes: 'qtip-bootstrap qtip-cart' },
                show: { ready: true },
            });
        };

        this.getqTipDelay = function (msg) {
            var seconds = 3; //at least visible for 3 seconds
            //returns 3 seconds + 0.15s per estimatet word (guessing each word is 6 letters)
            return (seconds + (msg.length / 6) * 0.15) * 1000;//returns values in milliseconds
        };

        this.onClickVat = function () {
            self.load('', '', true);
            return true; //Need this on Checkbox
        };

        this.onClickContinueShoping = function () {
            self.service.GetAction("ContinueShoping", "").then(function (result) {
                window.location.href = result;
            });
        };

        //Settings
        this.onClickRemoveCart = function () {
            self.service.GetAction("RemoveCart", { cartName: null, isCheckout: self.isCheckout() }).then(function (result) {
                if (result == null)
                    return;


                self.hasCart(false);
                self.priceTotal('');
                self.priceTotalInkVat('');
                self.showCurrencyInTotal(false);
                self.currency('');
                self.priceTotalProducts('');
                self.priceTotalProductsInkVat('');
                self.priceTotalProductsBeforeDiscountsInclVat('');
                self.priceTotalProductsBeforeDiscounts('');
                self.showLeasingCosts(false);
                self.leasingTermAmountExVat('');
                self.giftVoucherReduction('');
                self.giftVoucherValue('');

                self.priceTotalInkCarrier('');
                self.priceTotalInkCarrierInkVat('');

                self.vatTotal('');
                self.vatTotalInkCarrier('');

                self.cartItems.removeAll();
                self.showEmptyCart(true);

                PubSub.publish(mcWeb.cartsmall.events.onUpdateCart, "");
            });
        };

        this.onExternalCheckout = function(){
            document.location.href = "/WebPages/Cart/OciCheckout.aspx";
        };

        this.onClickGoToCheckout = function () {
            try {
                var data = { cartName: self.cartName, source: 'cart' };
                //startUpdateIcon();
                self.showRefreshSpin(true);

                self.service.GetAction("GoToCheckOut", data).then(function (result) {
                    //stopUpdateIcon();
                    self.showRefreshSpin(false);
                    if (result == null)
                        return;
                    window.location.href = result;  //"http://" + location.hostname;			
                });
            } catch (e) {
                //stopUpdateIcon();
                self.showRefreshSpin(false);
            }
        };

        this.LoadZipCode = function (zipCode) {
            if (zipCode != null && zipCode.length >= 3 && (zipCode.indexOf("*") == -1)) {
                try {
                    self.zipCodePrev(zipCode);
                    self.zipCode(zipCode);
                    var data = { zipCode: zipCode };
                    getLibrary("mcWeb.customerRegistration").then(() => {
                        PubSub.publish(mcWeb.events.customerRegistration.onChangedZipCode, data);
                    });
                } catch (e) {
                    //stopUpdateIcon();
                    self.showRefreshSpin(false);
                }
            }
        };

        this.loadGiftcards = function(guid){
            if(guid === undefined || guid === "" || guid.length <= 0)
                return;

            var giftcardParam = {
                Guid: guid,
                IsCheckout: self.isCheckout()
            };
            self.giftcardService.PostAction("VerifyGiftcardsForCartAsync", giftcardParam).then(function (resultGiftcards){
                
                if(resultGiftcards !== undefined && resultGiftcards !== null  && resultGiftcards.Items !== undefined && resultGiftcards.Items.length > 0){
                    self.giftcardsAdded(true);

                    ko.utils.arrayForEach(resultGiftcards.Items, function (item) {
                        if (!ko.isObservable(item.Guid)) {
                            item.Guid = ko.observable(item.Guid);
                        }

                        if (!ko.isObservable(item.ShortGuid)) {
                            item.ShortGuid = ko.observable(item.ShortGuid);
                        }

                        if (!ko.isObservable(item.DeductionAmountFormatted)) {
                            item.DeductionAmountFormatted = ko.observable(item.DeductionAmountFormatted);
                        }
                    });
                    self.giftcards(resultGiftcards.Items);
                    if (self.giftcardTotalDeduction() !== resultGiftcards.TotalGiftcardDeductions) {
                        PubSub.publish(mcWeb.payments.events.reloadPayments, null);
                    }

                    self.giftcardTotalDeduction(resultGiftcards.TotalGiftcardDeductions);
                }
                else{
                    self.giftcardsAdded(false);
                    self.giftcards(null);
                    self.giftcardTotalDeduction("");
                }
            });
        };



        this.loadCarrier = function (carrier) {

            if (carrier == null || !carrier)
                return;

            var previousCarrierId = self.previousCarrierId();
            self.selectedCarrierId(carrier.SelectedCarrierId);

            if (carrier.CarrierList && carrier.CarrierList.length > 0) {
                self.carrierTypes(carrier.CarrierList);

                for (var i = 0; i < carrier.CarrierList.length; i++) {
                    var obj = carrier.CarrierList[i];
                    if (obj.Id == carrier.SelectedCarrierId) {
                        self.selectedCarrierName(obj.Name);
                        self.selectedCarrierPrice(obj.PrintPrice);
                        self.previousCarrierId(carrier.SelectedCarrierId);
                        break;
                    }
                }
            }

            //if (previousCarrierId != -1 && previousCarrierId != self.selectedCarrierId()) {
            //	self.quantityQtip($('#cart-zipcode'), $('#carrier-changed').html(), self.selectedCarrierName());
            //}

        };

        this.isNumberKey = function (sender, e) {
            var key = (e.which) ? e.which : e.keyCode;
            if (key == 13) {
                document.activeElement.blur();
                return false;
            }
            return !(key > 31 && (key < 48 || key > 57));
        };

        self.zipCode.subscribe(function (zipCode) {

            if (self.zipCodePrev() == zipCode)
                return;

            if (zipCode != null && zipCode.length > 3) {
                self.zipCodePrev(zipCode);
                //document.activeElement.blur();
                self.LoadZipCode(zipCode);
            }
        });

        //PubSub.subscribe(mcWeb.shipment.events.onPickupPointCustomerSelected, function (message, selectedPickupPoint) {
        //    if (!selectedPickupPoint) return;

        //    var customerId = selectedPickupPoint.CustomerId;
        //    var customername = selectedPickupPoint.Customername;
        //    var msg = self.messageToSalesDep();

        //    if ((msg.indexOf(customername) === -1)) {
        //        msg = msg + " " + customername;
        //        self.messageToSalesDep(msg);
        //        self.storeMessages();
        //    }
        //});

        this.storeMessages = function () {
            var data = {
                messageToSalesDep: (self.messageToSalesDep() == null) ? "" : self.messageToSalesDep(),
                messageBookingRef: (self.messageBookingRef() == null) ? "" : self.messageBookingRef()
            }

            self.service.PostAction("StoreMessageToSalesDep", data).then(function (result) {
                if (result == null || result != true) {
                    alert('Error saving message!');
                }
            });
        };

        $('#qt-zipcode-i').popover({
            trigger: 'hover',
            title: $('#qt-zipcode-t').html(),
            content: $('#qt-zipcode-c').html(),
            placement: 'top',
            container: 'body'
        });

        this.showTotalPrice = function () {
            if (self.showLeasingCosts()) {
                $("#checkout-total").html(self.leasingTermAmountExVat());
            }
            else if(self.hideSomePricesForMport()){
                $("#checkout-total").html(self.SummarySumAfterCostReductionIncVat());
            }
            else{
                $("#checkout-total").html(self.priceTotalInkVat());
            }
            
        };

        this.hideTotalPrice = function(){
            $("#checkout-total").html("");
        }
        PubSub.subscribe(mcWeb.login.events.onIsloggedIn, function (message, isLoggedIn) {
            self.isLoggedIn(isLoggedIn);
        });

        self.onClickLoginDiscoutCode = function () {

            try {
                window.StorageService.sessionStorage.setItem('focusDiscoutCode', true);
            } catch (e) {
                // IOS/etc. Private Mode
            }

            if (self.hrefLogin() === '#login') {
                mcWeb.login.load();
            } else {
                window.location.href = self.hrefLogin();
            }
        };


        PubSub.subscribe(mcWeb.cart.events.focusDiscoutCode, function () {

            try {
                var focusDiscoutCode = window.StorageService.sessionStorage.getItem('focusDiscoutCode');
                if (focusDiscoutCode !== null && focusDiscoutCode === 'true') {

                    self.discountVisible(true);
                    window.StorageService.sessionStorage.setItem('focusDiscoutCode', false);

                    setTimeout(function () {
                        $("#discount-code-input").focus();
                    }, 400);
                }
            } catch (e) {
                // IOS/etc. Private Mode
                console.log('CartView.PubSub.subscribe(mcWeb.cart.events.focusDiscoutCode) - ex: ' + e);
            }
        });


        PubSub.subscribe(mcWeb.cart.events.onChangeCollectedDelivery, function (message, active) {

            self.service.GetAction("UseCollectedDelivery", { active: active, isCheckout: self.isCheckout() }).then(function (result) {
                if (result == null || result.Success === false) {
                    alert('Error saving collected delivery change!');
                }
                else if (result.MustRefreshCart) {
                    PubSub.publish(mcWeb.cart.events.onChangedCart, null);
                }
            });

        });

        PubSub.subscribe(mcWeb.cart.events.hasCartItems, function (message, hasCartItems) {
            if (hasCartItems == true) {
                if ($(".checkout.empty-cart").length > 0) {
                    $(".checkout").removeClass("empty-cart");
                    PubSub.publish("AjaxRenderingEngine.onFieldsRefresh", { parentId: '.checkout' });
                }
            } else {
                $(".checkout").addClass("empty-cart");
            }
        });



        /*Cart Item Info*/
        this.onClickShowSelectedCartItemTextbox = function (product) {
            var pid = 'productId-' + product.ProductId;
            if ($("#" + pid).is(":visible"))
                $("#" + pid).slideUp();
            else
                $("#" + pid).slideDown();
        };

        this.onClickSaveCartItemInfo = function (product) {
            if (product.Info() == null)
                return;

            self.updateInfo(product);
        };

        this.updateInfo = function (product) {
            var quantity = convertToDesimal(product.Quantity());
            var data = {
                plid: product.ProductId,
                quantity: quantity,
                cartName: null,
                isCheckout: self.isCheckout(),
                info: product.Info()
            };

            self.showRefreshSpin(true);

            self.service.GetAction("UpdateCartItem", data).then(function (result) {
                self.showRefreshSpin(false);

                if (result == null)
                    return;
            });
        };

        /// Data = {status: true/false, msg: 'Ny vare...'}
        PubSub.subscribe(mcWeb.cart.events.onShowNewItemInCartText, function (message, data) {

            self.popupMsgWait.hide();
            self.popupMsgText.show();
            if (data.status == true) {
                self.popupMsgSuccess.show();
            } else {
                self.popupMsg.addClass("notifier-error");
                self.popupMsgError.show();
            }

            self.popupMsgText.html(data.msg);
            self.popupMsg.fadeIn();
            if (data.popupTime != undefined && data.popupTime != null) {
                self.popupTime = data.popupTime;
            }
            setTimeout(function () {
                PubSub.publish(mcWeb.cart.events.onHideNewItemInCart);
            }, self.popupTime);
        });

        var isRunningPop = false;
        PubSub.subscribe(mcWeb.cart.events.onShowNewItemInCart, function (message) {
            if (isRunningPop == true) {
                return;
            }

            isRunningPop = true;
            self.popupMsgText.hide();
            self.popupMsgWait.show();
            self.popupMsg.fadeIn();
            //IMPORTAN - Use "mcWeb.cartsmall.events.onShowNewItemInCartText" after this!
        });

        PubSub.subscribe(mcWeb.cart.events.onHideNewItemInCart, function () {
            self.popupMsg.fadeOut(700, function () {
                self.popupMsgSuccess.hide();
                self.popupMsgError.hide();
                self.popupMsg.removeClass("notifier-error");
            });

            isRunningPop = false;
        });

        this.setFavoriteGuid = function (favoriteGuid, isLoggedIn) {

            try {
                if (favoriteGuid == null || favoriteGuid.length < 30) {
                    window.StorageService.localStorage.removeItem('sFavCartId');
                } else {
                    var sFavCartId = (isLoggedIn) ? (favoriteGuid + ";l") : favoriteGuid;
                    window.StorageService.localStorage.setItem('sFavCartId', sFavCartId);
                }
            } catch (e) {
                // IOS/etc. Private Mode
            }
        };

        this.getFavoriteGuid = function () {

            try {
                var sFavCartId = window.StorageService.localStorage.getItem('sFavCartId');

                if (sFavCartId === null || sFavCartId === undefined || sFavCartId.length < 30)
                    return null;

                window.StorageService.localStorage.removeItem('sFavCartId'); //reset
                return sFavCartId;
            } catch (e) {
                // IOS/etc. Private Mode
                console.log('CartView.getFavoriteGuid - ex: ' + e);
            }
            return null;
        };

        self.showTemplate = function (html) {

            var template = $('#lightbox-placeholder');
            if (template.length < 1) {
                PubSub.publish(mcWeb.checkout.events.onShowSendOrder, { showBtn: false, disabledBtn: false });
                return;
            }

            template.html(html);
        };

    };
});